// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file DropdownMenuContext.tsx
 * @output Exports context and hook for compound-component menu coordination
 * @position Internal; used by DropdownMenu and DropdownMenuItem
 *
 * Provides menu state (close callback, size) to compound children.
 * Keyboard navigation is handled by useListFocus on the menu container —
 * items don't need to register themselves.
 */
import { createContext, use } from 'react';

/** Menu size, derived from the trigger button size. */

export const DropdownMenuContext = /*#__PURE__*/createContext(null);
DropdownMenuContext.displayName = 'DropdownMenuContext';

/**
 * Hook for compound menu items to access menu state.
 * Returns null outside of a DropdownMenu.
 */
export function useDropdownMenuContext() {
  return use(DropdownMenuContext);
}

// =============================================================================
// Radio group coordination
// =============================================================================

export const DropdownMenuRadioGroupContext = /*#__PURE__*/createContext(null);
DropdownMenuRadioGroupContext.displayName = 'DropdownMenuRadioGroupContext';

/**
 * Read the enclosing radio group's selection state.
 * Returns null when used outside a DropdownMenuRadioGroup.
 */
export function useDropdownMenuRadioGroupContext() {
  return use(DropdownMenuRadioGroupContext);
}